import React, { useState } from 'react';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import styled, { css } from 'styled-components';
import { useNotification } from '../contexts/NotificationContext';

interface Props {
  isOpen: boolean;
  toggleNotification: () => void;
  message: React.ReactNode;
  action: React.ReactNode;
}

const StyledSnackbar = styled(Snackbar)`
  ${({ theme }) => css`
    & .MuiSnackbarContent-root {
      max-width: 775px;
      width: 100%; 
      padding: 18px;
      flex-shrink: 0;
      border-radius: 8px;
      border: 1px solid ${theme.NumberColor};
      background: ${theme.notificationBackground};
      color: ${theme.secondaryButtonBackground};
      backdrop-filter: blur(12px);
    }
      & .MuiSnackbarContent-message {
      padding: 0px;
      }
      & .MuiSnackbarContent-action {
      margin-right: 0px;
      }
  `}
`;

const NotificationComponent: React.FC = ({ }) => {
  const { isOpen, message, action, hideNotification } = useNotification();
  const [state] = React.useState<SnackbarOrigin>({
    vertical: 'bottom',
    horizontal: 'center',
  });



  return (
    <StyledSnackbar
      className="filters-altered"
      anchorOrigin={state}
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        hideNotification();
      }}
      key={state.vertical + state.horizontal}
      action={action || undefined}
      message={message}
    />
  );
}

export default NotificationComponent;
